// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"17c6a741","398":"cffa31ed"}[chunkId] + ".chunk.css";
};